import { Text, PresentationControls, Environment, Float, useGLTF, Html } from "@react-three/drei";

export default function Experience() {
    const computer = useGLTF('/model/macbook_model.gltf')
    // #241a1a
    return <>
        <Environment preset="city" />
        {/* <color args={['#483D3F']} attach="background" /> */}
        <color args={['#2D2D2A']} attach="background" />
        {/* <mesh>
            <boxGeometry />
            <meshNormalMaterial />
        </mesh> */}
        <PresentationControls global rotation={[0.13, 0.1, 0]} polar={[-0.1, 0.2]} azimuth={[-1, 0.75]} damping={0.1} snap>
            <Float rotationIntensity={0.4}>
                <rectAreaLight
                    width={2.5}
                    height={1.65}
                    intensity={65}
                    color={'#E5ECE9'}
                    rotation={[0.1, Math.PI, 0]}
                    position={[0, 0.55, -1.55]}
                />
                <primitive object={computer.scene} position-y={-1.2}>
                    <Html
                        transform
                        wrapperClass="htmlScreen"
                        distanceFactor={1.17}
                        position={[0, 1.56, -1.4]}
                        rotation-x={-0.256}
                    >
                        <iframe src="./page.html" />
                    </Html>
                </primitive>
                <Text
                    font="./fonts/DynaPuff-Regular.woff"
                    fontSize={0.8}
                    position={[2, 0.5, 0.1]}
                    rotation-y={-1.5}
                    maxWidth={2}
                    textAlign="center"
                >
                    SUBIK STHA
                </Text>
            </Float>
        </PresentationControls>
        {/* <ContactShadows position-y={-2} opacity={0.4} scale={5} /> */}
    </>
}